import { HorseTipsterModel } from './HorseTipsterModel';

export class HorseGeneralTipsModel {
  id: number;
  tipster: HorseTipsterModel;
  price: number;
  notes: string;
  availableForPurchase: boolean;
  purchased: boolean;
  voucherCost: number;
  allowRefund: boolean;
  createDate: string;
  postDate: string;
  status: number;
  imgSrc: string;
  image1: string;
  image2: string;
  image3: string;

  constructor(id: number, tipster: HorseTipsterModel, price: number, notes: string,
    availableForPurchase: boolean, purchased: boolean, voucherCost: number,
    allowRefund: boolean, createDate: string, postDate: string, status: number, imgSrc: string, image1: string, image2: string, image3: string) {
    this.id = id;
    this.tipster = tipster;
    this.price = price;
    this.notes = notes;
    this.availableForPurchase = availableForPurchase;
    this.purchased = purchased;
    this.voucherCost = voucherCost;
    this.allowRefund = allowRefund;
    this.createDate = createDate;
    this.postDate = postDate;
    this.status = status;
    this.imgSrc = imgSrc;
    this.image1 = image1;
    this.image2 = image2;
    this.image3 = image3;
  }

  canUseVoucher(): boolean {
    return this.voucherCost > 0;
  }

}



// WEBPACK FOOTER //
// ./src/model/horse/HorseGeneralTipsModel.ts